import { render, staticRenderFns } from "./WysiwygField.vue?vue&type=template&id=cc9f7c44&scoped=true&"
import script from "./WysiwygField.vue?vue&type=script&lang=js&"
export * from "./WysiwygField.vue?vue&type=script&lang=js&"
import style0 from "./WysiwygField.vue?vue&type=style&index=0&id=cc9f7c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9f7c44",
  null
  
)

export default component.exports